import templateUrl from './info-modal.component.html'

export const InfoModalComponent = {
    templateUrl,
    controller: InfoModalController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}




function InfoModalController($scope, $state, $transitions) {
    'ngInject';
    const vm = this;
    vm.notification = "Your form is not completed yet. Do you want to leave?";
    vm.onSubmit = onSubmit;
    vm.onClose = onClose;
    vm.source;
    vm.cancel = 'Cancel';
    vm.continue = 'Continue';
    vm.showCancel = true;

    vm.$onInit = function () {
        console.log(vm.resolve);
        vm.notification = vm.resolve?.notification ?? vm.notification;
        vm.cancel = vm.resolve?.cancel ?? vm.cancel;
        vm.continue = vm.resolve?.continue ?? vm.continue;
        vm.showCancel = vm.resolve?.showCancel ?? true;
    }

    //$scope.$on('modal.closing', function (event, reason, closed) {
    //    return onClose();
    //});

    //$transitions.onSuccess({}, function (transition) {
    //    vm.source = transition.from().name
    //    console.log("Successful Transition 2 from " + transition.from().name + " to " + transition.to().name);
    //});

    function onSubmit() {
        if (vm.resolve.state) {
            vm.close({ $value: 'ok' });
            return vm.resolve.params != null ? $state.go(vm.resolve.state, vm.resolve.params) : $state.go(vm.resolve.state);
        }
        vm.close({ $value: 'ok' });

    }

    function onClose() {
        //var source = vm.resolve.source ?? 'application-status'
        //if (source) {
        //    return $state.go(vm.resolve.source);
        //}
        vm.close({ $value: 'cancel' });
    }
}


export const InfoModal = {
    component: "apexInfoModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'xs',
    backdrop: 'static'
}
